import { Commit, createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
import translation from '@/store/modules/translation'
import channel from '@/store/modules/channel'
import share from './modules/share';

export const store =  createStore({
  plugins: [
    createPersistedState({
      //storage: window.sessionStorage,
      storage: window.localStorage,
    })
  ],
  state: {
    authenticated : false,
    isAdmin : false,
    authUser: {},
  },
  mutations: {
    SET_AUTH: (state: {authenticated: boolean}, auth: boolean) => state.authenticated = auth,
    SET_IS_ADMIN: (state: {isAdmin: boolean}, admin: boolean) => state.isAdmin = admin,
    SET_AUTH_USER: (state: {authUser: any}, user: any) => state.authUser = user,
  },
  actions: {
    //create a function to set authenticated flag true
    //commit some changes via setAuth so mutations can handle it
    setAuth: ({commit}:{commit:Commit}, auth: boolean) => commit("SET_AUTH", auth),

    setAdmin: ({commit}:{commit:Commit}, isAdmin: boolean) => commit("SET_IS_ADMIN", isAdmin),

    setAuthUser: ({commit}:{commit:Commit}, user: any) => commit("SET_AUTH_USER", user),
    
  },
  modules: {
    translation,
    channel,
    share
  },
})

export function useStore() {
  return store;
}
